export const planningContractTypes = {
  cdi: { label: 'CDI', className: 'border-blue-200 bg-blue-50 text-blue-900' },
  cdd: { label: 'CDD', className: 'border-violet-200 bg-violet-50 text-violet-900' },
  vacation: { label: 'Vacation', className: 'border-pink-200 bg-pink-50 text-pink-900' },
  interim: { label: 'Intérim', className: 'border-emerald-200 bg-emerald-50 text-emerald-900' },
};
export function planningContractType(contract) {
  const value = contract.contractType || contract.typeContrat || contract.TypeContrat || contract.service;
  const key = String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  return planningContractTypes[key] || { label: 'Type non renseigné', className: 'border-slate-200 bg-slate-50 text-slate-700' };
}
